import queryString from 'querystring';

import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";


let redux = reduxCreator.type('ARTICLE_COMMENT').plugin(axiosPlugin);

let fetchArticleCommentAction = redux.fetchActionGetOne();

let createArticleCommentAction = redux.fetchActionCreate();

let updateArticleCommentAction = redux.fetchActionUpdate();

let deleteArticleCommentAction = redux.fetchActionDelete();

export const TYPES = redux.types;

export const fetchArticleComment = (articleId, commentId, query = {}) => fetchArticleCommentAction(`/articles/${articleId}/comments/${commentId}?${queryString.stringify(query)}`);
export const createArticleComment = (articleId, data) => createArticleCommentAction(`/articles/${articleId}/comments`, data);
export const updateArticleComment = (articleId, commentId, data = {}) => updateArticleCommentAction(`/articles/${articleId}/comments/${commentId}`, data);
export const deleteArticleComment = (articleId, commentId = {}) => deleteArticleCommentAction(`/articles/${articleId}/comments/${commentId}`);
export const resetArticleComment = () => redux.actions.reset();

export const articleComment = redux.reducer();